import './login.scss';
import { useTranslation } from 'react-i18next';
import Logo from '../../../assets/img/logo.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import decodeToken from '../../../utils/decode-token';
import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import axios from 'axios';
import { Alert } from '@mui/material';
import getRoleRedirectPath from '../../../utils/role-redirect';
import { isTranslationsFeatureEnvironment } from '../../../utils/role-utils';


const Login = () => {
  sessionStorage.clear();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useParams();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  // ✅ recarga solo la primera vez
  useEffect(() => {
    const hasReloaded = localStorage.getItem('login_reloaded_once');

    if (!hasReloaded) {
      localStorage.setItem('login_reloaded_once', 'true');
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    if (logout) {
      setSnackbarMessage(t('login-logout'));
      setSnackbarOpen(true);
    }
  }, [logout, t]);

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        { email, password }
      );

      if (response.data.token && response.data.refresh_token) {
        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('refresh_token', response.data.refresh_token);
      }

      let role = decodeToken(response.data.token).role;

      const isTranslationsOnlyRole = role === 'translator' || role === 'reviewer';
      if (isTranslationsOnlyRole && !isTranslationsFeatureEnvironment()) {
        sessionStorage.clear();
        setSnackbarSeverity('warning');
        setSnackbarMessage(
          t('login-translations-unavailable', {
            defaultValue: 'Translation accounts are not available in this environment.',
          })
        );
        setSnackbarOpen(true);
        return;
      }

      navigate(getRoleRedirectPath(role));

    } catch (error) {
      console.error('Error de autenticación:', error);
      setError(true);
      document.querySelector('.error-msg').classList.remove('hidden');
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (id === 'email') setEmail(value);
    if (id === 'password') setPassword(value);

    if (error) {
      setError(false);
      document.querySelector('.error-msg').classList.add('hidden');
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  let env = `${process.env.REACT_APP_ENV_NAME}`;

  return (
    <div className="App">
      <main className="login">
        {(env === 'LOCAL' || env === 'STAGING' || env === 'PRE') && (
          <div className="enviroment-tag">{env}</div>
        )}

        <div className="inner">
          <img src={Logo} alt="Range Rover Colective" className="logo" />

          <form onSubmit={onSubmitHandler}>
            <div className={`form-control ${error ? 'error' : ''}`}>
              <label htmlFor="email">{t('common-user')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </div>

            <div className={`form-control ${error ? 'error' : ''}`}>
              <label htmlFor="password">{t('common-key')}</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </div>

            <p className="error-msg hidden">{t('login-error')}</p>

            <button className="btn" type="submit">
              {t('login-action')}
            </button>
          </form>

          <p>
            <Link to="/password-recovery">
              {t('login-password-recovery')}
            </Link>
          </p>
        </div>
      </main>

      <Snackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
      >
        <Alert
          severity={snackbarSeverity}
          className="login-toast"
          style={{ backgroundColor: '#FFFFFF' }}
          action={
            <button type="button" className="login-toast__dismiss" onClick={handleSnackbarClose}>
              {t('common-dismiss', { defaultValue: 'Dismiss' })}
            </button>
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Login;